(function () {
  function tryPlayVideo(container) {
    if (!container) return;
    var video = container.querySelector('video');
    if (video && video.paused) {
      video.play().catch(function () {});
      return;
    }
    if (typeof container.loadContent === 'function') {
      if (!container.getAttribute('loaded')) {
        container.loadContent(false);
        return;
      }
      var deferredVideo = container.querySelector('video');
      if (deferredVideo && deferredVideo.paused) {
        deferredVideo.play().catch(function () {});
      }
    }
  }

  function collectTargets() {
    return document.querySelectorAll(
      '.product__media-list .product-media-autoplay[data-media-id], .product__media-list deferred-media[data-media-id]'
    );
  }

  function initIntersectionWatch() {
    var items = collectTargets();
    if (!items.length || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) tryPlayVideo(entry.target);
        });
      },
      { threshold: 0.6 }
    );
    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  // Also watch the slider's own scroll position directly: covers real touch
  // swipes and the prev/next arrow buttons, which move the list's scrollLeft.
  function initScrollWatch() {
    document.querySelectorAll('.product__media-list').forEach(function (list) {
      var items = list.querySelectorAll(
        '.product-media-autoplay[data-media-id], deferred-media[data-media-id]'
      );
      if (!items.length) return;

      var timeout;
      function checkActive() {
        var listRect = list.getBoundingClientRect();
        if (!listRect.width) return;
        var center = listRect.left + listRect.width / 2;
        items.forEach(function (el) {
          var li = el.closest('li');
          if (!li) return;
          var rect = li.getBoundingClientRect();
          if (rect.width > 0 && center >= rect.left && center <= rect.right) {
            tryPlayVideo(el);
          }
        });
      }

      list.addEventListener(
        'scroll',
        function () {
          clearTimeout(timeout);
          timeout = setTimeout(checkActive, 120);
        },
        { passive: true }
      );

      checkActive();
    });
  }

  // Covers the desktop "thumbnail" gallery layout, where slides aren't
  // scrolled into view at all: they're stacked and toggled with a class
  // (is-active) instead. A MutationObserver on class changes catches that.
  function initActiveClassWatch() {
    var lists = document.querySelectorAll('.product__media-list');
    lists.forEach(function (list) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          var li = mutation.target;
          if (li.classList && li.classList.contains('is-active')) {
            var el = li.querySelector('.product-media-autoplay[data-media-id], deferred-media[data-media-id]');
            if (el) tryPlayVideo(el);
          }
        });
      });
      Array.prototype.forEach.call(list.children, function (li) {
        observer.observe(li, { attributes: true, attributeFilter: ['class'] });
        if (li.classList.contains('is-active')) {
          var el = li.querySelector('.product-media-autoplay[data-media-id], deferred-media[data-media-id]');
          if (el) tryPlayVideo(el);
        }
      });
    });
  }

  function init() {
    initIntersectionWatch();
    initScrollWatch();
    initActiveClassWatch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
